const ID = 'table';

export default ID;
